import { render, staticRenderFns } from "./AdminLocalization.vue?vue&type=template&id=61580684"
import script from "./AdminLocalization.vue?vue&type=script&lang=js"
export * from "./AdminLocalization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports